<template>
    <div>
        <MenuTopTemplate :titulo="'PAGAMENTO PIX'" :icone="require('../assets/icons/pix.png')" :onPressedClose="fechar"/>

        <DeliverySucessoView/>

    </div>
</template>

<script>
import MenuTopTemplate from '@/components/Base/MenuTopTemplate.vue';
import DeliverySucessoView from './DeliverySucessoView.vue';


export default {
    name: "DeliverySucessoPixView",
    created() {
    },
    methods: {
        fechar() {
            this.$router.push({ path: '/cardapio' });
        },
    },
    components:{DeliverySucessoView,MenuTopTemplate}
}
</script>

<style scoped>

</style>